import React from 'react';
import { AppButton, Box } from '@common-fe/common-fe';

import { usePlanReactivationModalStore } from '../stores';

import { ResumeHeader } from './ResumeHeader';
import { ResumeNextSteps } from './ResumeNextSteps';

export const PlanReactivationResume = () => {
  const handleChangeVisibility = usePlanReactivationModalStore((state) => state.handleChangeVisibility);
  const handleReset = usePlanReactivationModalStore((state) => state.handleReset);
  const additionalAction = usePlanReactivationModalStore((state) => state.additionalAction);
  const planName = usePlanReactivationModalStore((state) => state.planName);
  const planNames = usePlanReactivationModalStore((state) => state.planNames);
  const isBulkMode = usePlanReactivationModalStore((state) => state.isBulkMode);

  const handleGotIt = () => {
    handleChangeVisibility(false);
    handleReset();
    
    if (additionalAction) {
      additionalAction();
    }
  };

  return (
    <Box data-testid="PlanReactivationResume">
      <ResumeHeader 
        planName={planName}
        planNames={planNames}
        isBulkMode={isBulkMode}
        testId="PlanReactivationResume_header" 
      />

      <ResumeNextSteps testId="PlanReactivationResume_next-steps" />

      <Box align="center" margin={{ bottom: 'spacing24' }}>
        <AppButton
          testId="PlanReactivationResume_got-it"
          type="button"
          onClick={handleGotIt}
          width="200px"
        >
          Got it!
        </AppButton>
      </Box>
    </Box>
  );
};
